import React from 'react';
import { Spin } from 'antd';
import styles from './index.module.less';
export default function LoadingWrapper(props) {
    const { loading, children, style } = props;
    return (<>
      {loading ? (<div className={styles['loading']} style={style}>
          <Spin size="large"/>
        </div>) : (children)}
    </>);
}
